<template>
    <div class="mailchimp-pattern">
        <IntegrationComponent
            ref="integration"
            :integration="integration"
            @integration-message="handleMessage"
            @integration-select-account="handleSelectAccount"
            @integration-activate="handleActivate"
            @integration-close="handleClose"
        >
            <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54">
                    <g fill="none">
                        <path
                            fill="#684C46"
                            d="M51.22 38.23c-.04.132-3.893 14.939-19.028 14.934-13.083-.004-19.284-11.376-19.284-11.376a6.778 6.778 0 01-2.722-.41c-3.839-1.41-5.68-5.801-4.356-9.486L3.72 30.28C-4.452 24.055 18.698-4.432 26.885 2.014l1.954 1.572c2.939-1.785 5.85-2.75 8.216-2.75 1.68 0 3.086.486 4.032 1.511 2.125 2.3 1.362 6.694-1.54 11.142.624.592 1.142 1.397 1.51 2.197.923.711 1.52 1.793 1.818 3.288.33 1.661.4 4.028.607 5.045.782.353.45.19 1.283.606.87.435 1.93.964 3.1 2.09 2.08.522 2.875 2.734 1.658 4.244-.033.04-.18.215-.332.388.036.096.435.742.723 2.058.862.204 1.549.735 1.91 1.505.623 1.506-.604 3.319-.604 3.319v.001z"
                        />
                        <path
                            fill="#F5DCBA"
                            d="M15.995 32.658c.33-.838.496-1.526.496-1.526.378 1.154.57 2.367.495 3.593.313-.416.648-1.2.648-1.2.582 3.426-1.918 6.562-5.211 6.562-2.924 0-5.295-2.496-5.295-5.574s2.37-5.574 5.295-5.574c.758 0 1.479.168 2.13.47 0 0 1.126.567 1.442 3.249zm28.812 12.08c4.104-3.225 4.821-7.11 4.89-7.243 1.01-1.211.735-2.405-.6-2.405-.424 0-.744.112-.744.112s.004-1.768-.813-3.144c-.63.709-2.38 2.113-4.676 3.203-2.152 1.022-5.025 1.917-8.585 2.035-.997.044-1.613-.118-1.96 1.044-.111.41-.063 1.02.02 1.196.281.963 1.015 1.387 1.98 1.612.733.17 1.51.186 1.51.186 7.22.203 13.017-5.428 13.086-5.475a1.14 1.14 0 00.123-.12l-.072.166c-1.042 2.345-7.08 6.598-13.09 6.476l-.019.007c-1.394-.005-3.087-.364-3.967-1.455-1.393-1.728-.67-4.6 1.55-4.667l.74-.017c5.496-.17 10.428-2.189 13.96-6.406.485-.603-.057-1.432-1.11-1.457a.035.035 0 01-.024-.01c-1.248-1.337-2.345-1.809-3.32-2.304-2.046-1.043-1.854-.142-2.33-5.197-.128-1.363-.386-3.221-1.583-3.934a1.95 1.95 0 00-1.013-.267c-.352 0-.524.072-.593.087-.655.146-1.028.517-1.495.948-2.208 2.035-3.972 1.483-6.605 1.46-2.473-.022-4.657 1.703-5.074 4.352l-.001.002c-.203 1.387-.072 2.796.146 3.43 0 0-.672-.447-.991-.843.387 2.42 2.595 4.002 2.595 4.002-.348.08-.848.047-.848.047.002.002 1.26.997 2.352 1.344-.284.177-1.724 1.598-2.466 3.553-.695 1.83-.412 4.027-.412 4.027l.603-.9s-.394 2.005.369 3.946c.253-.578.806-1.608.806-1.608s-.088 2.152.948 3.915c.027-.407.183-1.443.183-1.443s.594 1.838 1.968 3.123c2.571 2.282 9.38 2.694 14.562-1.378z"
                        />
                        <path
                            fill="#0788BF"
                            d="M6.623 30.324c-.021-.005-1.993-1.452-2.273-1.929-1.659-2.799 1.227-8.548 3.28-11.816C12.706 8.502 21.153 2.128 24.99 3.038l3.94 2.034c-1.53.9-3.01 2.005-3.896 2.74l-.838.703s-2.449 1.648-3.667 2.687c-4.88 4.166-9.687 10.613-11.47 16.838 0 0-1.464.726-2.436 2.284z"
                        />
                        <path
                            fill="#46B8E3"
                            d="M24.99 3.038c-3.837-.91-12.284 5.463-17.36 13.54l-.004.007.02.003 4.045 3.183c4.44-7.048 10.02-10.682 10.178-10.789l-.641-4.313 1.2-.576 2.411.781-.184-.805.335-1.031z"
                        />
                        <path
                            fill="#FFD14F"
                            d="M28.93 5.071l-3.896 2.74-.273.214-3.454-2.823-.08-.533 1.202-.575 2.41.78.04-1.496.11-.34 1.056-.405z"
                        />
                        <path
                            fill="#122030"
                            d="M36.617 2.384c-2.576 0-5.468 1.355-7.687 2.687-.312.184-.62.375-.923.57l-1.161-.973.422 1.466c-.16.11-.315.218-.468.327l-2.399-.732 1.588 1.328c-.363.275-.686.532-.955.755l-3.806-3.143.201 1.408 2.767 2.438s-2.449 1.648-3.666 2.687c-4.882 4.166-9.688 10.613-11.47 16.838l.101-.057.042-.022.148-.077.096-.048c.05-.024.102-.047.153-.07l.09-.04.166-.064.076-.03c.08-.028.16-.055.241-.079 1.212-.361 2.86-.594 4.79.226.97-2.445 2.127-4.932 3.952-7.321 1.48-1.938 2.901-3.668 4.608-4.62 3.232-3.035 11.943-6.255 14.734-3.464.66-1.08 1.233-2.101 1.704-3.383 1.165-3.08 1.186-6.607-3.343-6.607h-.001zM25.56 5.107l-.57-2.07-.334 1.032.2.81.704.228z"
                        />
                        <path
                            fill="#FFF"
                            d="M48.353 35.2s.005-1.768-.813-3.144c-.63.709-2.38 2.113-4.676 3.203-2.152 1.022-5.025 1.917-8.585 2.035-.997.044-1.613-.118-1.96 1.044-.027.1-.045.212-.055.327v.011a2.82 2.82 0 00-.006.393v.006l.002.018c.003.05.007.1.012.146l.001.007.001.007c.024.185.06.27.065.28v.001l.005.016c.284.951 1.015 1.372 1.975 1.596.733.17 1.51.186 1.51.186 5.89.166 10.835-3.552 12.493-4.952.028-.393.045-.672.03-1.18h.001zM31.43 3.735c1.407-.65 2.915-1.162 4.361-1.31-1.436.324-3.187 1.069-5.261 2.338-.05.03-4.908 3.307-7.876 6.251-1.617 1.604-8.111 9.392-8.106 9.386 1.187-2.247 1.969-3.35 3.848-5.712a52.957 52.957 0 013.357-3.837c.39-.403.783-.795 1.178-1.174.15-.144 3.544-3.619 8.499-5.942z"
                        />
                        <path
                            fill="#EABE8D"
                            d="M44.807 44.738a14.354 14.354 0 01-2.19 1.418c-1.734-.659-2.798-2.063-2.798-2.063s1.487-.352 3.474-1.363c2.418-1.228 4.677-3.002 6.404-5.235-.069.134-.786 4.018-4.89 7.243zm-4.72-18.723c-.84-.597-2.229-.122-2.535.866.485.024 1 .391.969.861a1.86 1.86 0 011.304-.51c-.229-.367-.113-.999.261-1.217h.001zm-8.802 12.048c.264-.983 1.01-1.762 2.154-1.797l.74-.018c5.497-.168 10.429-2.188 13.96-6.405.486-.603-.057-1.432-1.109-1.457h-.015c-.178.188-.21.532-.504 1.046-1.074 1.866-2.56 2.719-4.541 3.71-6.074 3.023-9.223 1.616-10.487 3.467-.368.545-.374 1.154-.198 1.454zm10.99-12.681c-.581-.417-.602-1.144-.919-4.507-.101-1.073-.283-2.453-.94-3.339-.135-.119-.326-.255-.6-.255-.415-.018-.884.412-1.15.705-.754 1.089-1.475 1.79-2.75 2.398a8.282 8.282 0 01-3.788.755c-.931-.03-1.747-.183-2.547-.193-1.482-.023-2.766.457-3.702 1.639-.642.81-.9 1.667-.982 2.687.008.27.028.541.06.81.065.517.158.785.158.785l-.002.012.024.073s-.671-.446-.991-.842c.323 2.018 1.91 3.453 2.43 3.874l.09.07.008.008.067.05c-.348.08-.848.047-.848.047.002.002 1.26.997 2.353 1.344 1.448-1.224 3.091-1.694 4.44-1.84a35.888 35.888 0 012.64-1.486c-.287-1.779 1.291-3.57 3.277-3.743 1.498-.109 2.227.563 2.752 1.28.285-.09.606-.19.965-.295a.296.296 0 01-.045-.037zm.716 11.983a.291.291 0 00-.055.009c-.599.139-6.771 2.53-10.673 1.304-.017.213-.012.662.076.857v.001c.59.119 1.337.194 2.204.194 5.135 0 8.835-2.334 8.448-2.365zm-28.724-.48l.005-.003a1.49 1.49 0 00.37-1.254c-.116-.646-.848-.777-1.332-1.279l-.023-.024-.024-.027-.002-.001a1.082 1.082 0 01-.275-.79c.038-.66.625-.847.93-.725 0 0 .363.086.643.477v-.001c-.042-.13-.034-.338-.253-.65-.36-.509-1.187-1.028-2.359-.78-.216.047-.095.02-.308.08a.809.809 0 00-.09.03c-.067.032-.13.053-.19.085-.03.017-.206.097-.418.257-1.317 1.7.914 4.783 3.326 4.605z"
                        />
                        <path
                            fill="#9C7356"
                            d="M33.687 26.42c.112.163.141.286.096.337-.089.105-.41-.037-.882-.22-1.209-.452-2.1-.52-3.677.077-.399.152-.681.27-.817.249-.221-.033-.007-.438.476-.83.973-.777 2.309-1.017 3.45-.593.5.184 1.061.551 1.355.98h-.001zm-.24 1.238c-.33-.253-.941-.423-1.575-.316-.133.02-.256.062-.377.094a2.186 2.186 0 00-.837.484c-.253.245-.324.472-.251.527.072.058.246-.027.517-.136.905-.377 1.545-.387 2.155-.344.294.02.491.037.537-.043.032-.054-.026-.158-.168-.266h-.001zM13.958 32.3h.001c.149.118.262.244.347.365.279.394.19.624.304.735.042.04.1.054.16.03.157-.065.235-.317.25-.492.04-.422-.184-.895-.478-1.23l-.001-.002a2.588 2.588 0 00-.701-.563 2.919 2.919 0 00-.973-.333 3.658 3.658 0 00-1.41.079h.001c-.088.025-.197.048-.291.085-1.019.397-1.689 1.126-1.987 2.091a3.649 3.649 0 00-.07 1.83c.086.394.262.837.537 1.128v.001c.344.372.721.3.56-.045-.038-.096-.246-.487-.274-1.195a3.493 3.493 0 01.216-1.386c.094-.239.223-.47.391-.679.346-.423.771-.612.82-.64.06-.032.123-.053.19-.085a.795.795 0 01.09-.03c.213-.06.092-.033.309-.08.814-.172 1.515.017 2.01.416h-.001zm-.173 1.573a.489.489 0 01-.196-.283c-.046-.213-.022-.337.16-.465.14-.096.254-.142.254-.203.006-.114-.463-.232-.792.091-.272.29-.358.896.077 1.368.484.523 1.237.646 1.354 1.303.015.093.027.197.019.299.001.117-.038.286-.04.297-.145.635-.748 1.24-1.74 1.086-.183-.027-.302-.05-.337.001-.077.107.349.594 1.128.576.762-.016 1.518-.587 1.76-1.445.003-.01.075-.254.08-.472a1.962 1.962 0 00-.027-.501c-.199-1.101-1.293-1.328-1.7-1.652zm26.564-7.864c-.301-.047-.598.25-.662.663-.065.413.127.786.429.833.3.047.597-.25.662-.663.064-.413-.128-.786-.429-.833zm-3.31 1.205c-.165.302.037.731.45.958.415.227.885.166 1.05-.136.166-.302-.035-.73-.45-.958-.414-.227-.884-.166-1.05.136zm-12.125-12.22c5.7-3.695 11.393-4.12 13.344-2.62-.014-.04-.03-.08-.047-.12-.496-1.053-1.651-1.787-2.68-2.081.18.187.441.53.547.735a8.2 8.2 0 00-2.887-1.227s.129.092.15.113c.215.2.501.516.618.787-1.03-.413-2.331-.645-3.446-.43l-.139.032.177.045c.37.11.897.335 1.13.644-1.85-.326-3.885.035-4.982.648.14-.006.14-.006.259-.003.403.01 1.217.065 1.558.283-1.167.237-2.855.759-3.764 1.54.16-.018 1.071-.134 1.444-.074-5.003 2.863-7.28 7.191-7.28 7.191 1.475-1.922 3.388-3.772 5.998-5.463z"
                        />
                        <path
                            fill="#684C46"
                            d="M38.36 23.065c-.007-.393.055-1.042.425-1.163.632-.22 1.47 1.4 1.508 2.836a3.168 3.168 0 00-1.69-.303 4.866 4.866 0 01-.243-1.37z"
                        />
                    </g>
                </svg>
            </template>
            <template #configure>
                <div class="mailchimp-pattern__step">
                    <h2>Choose a Mailchimp list</h2>
                    <p>
                        When a respondent of this questionnaire gives you their email, we'll add it
                        to the list you choose.
                    </p>
                    <RowComponent justify="center">
                        <SelectComponent
                            :options="mailchimpLists"
                            placeholder="Choose a list..."
                            @select="handleSelectList"
                        />
                    </RowComponent>
                </div>
            </template>
        </IntegrationComponent>
    </div>
</template>

<script>
import IntegrationService from '@/services/integration-service'

export default {
    name: 'MailchimpPattern',

    data() {
        return {
            integration: {
                name: 'Mailchimp',
                description:
                    'Send respondents’ email addresses and names to your Mailchimp lists, and let us magically create sections with these email lists.'
            },
            integrationId: '',
            lists: [],
            listId: ''
        }
    },

    computed: {
        slug() {
            return this.integration.name
                .toLowerCase()
                .trim()
                .replace(/[\s\W-]+/g, '-')
        },

        mailchimpLists() {
            const lists = []

            this.lists.forEach((list) => {
                lists.push({
                    label: list.name,
                    value: list.id
                })
            })

            return lists
        }
    },

    methods: {
        async handleMessage(data) {
            const { id } = await this.$store.dispatch('integrations/addAccount', {
                type: 'mailchimp',
                email: data.login.login_email,
                access_token: data.access_token,
                expires_in: data.expires_in,
                api_endpoint: data.api_endpoint
            })

            this.integrationId = id
            this.fetchLists()

            this.$refs.integration.next()
        },

        handleSelectAccount(id) {
            this.integrationId = id
            this.fetchLists()

            this.$refs.integration.next()
        },

        async fetchLists() {
            const { data } = await IntegrationService.fetchMailchimpLists({
                id: this.integrationId
            })

            this.lists = data
        },

        handleSelectList({ value }) {
            this.listId = value

            this.$refs.integration.next()
        },

        async handleActivate() {
            await this.$store.dispatch('integrations/addIntegration', {
                type: this.slug,
                survey_id: this.$route.params.id,
                data: {
                    integration_id: this.integrationId,
                    settings: {
                        list_id: this.listId
                    }
                }
            })

            this.$refs.integration.next()

            setTimeout(() => {
                this.$refs.integration.close()
            }, 400)
        },

        handleClose() {
            Object.assign(this.$data, this.$options.data.apply(this))
        }
    }
}
</script>

<style lang="scss">
.mailchimp-pattern {
}

.mailchimp-pattern__step {
    display: flex;

    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;

    padding: 0 160px;

    .row-component {
        margin-top: 50px;
    }

    .fade-slide-in-enter-active,
    .fade-slide-in-leave-active {
        transition: all 0.4s ease;
    }

    .fade-slide-in-enter,
    .fade-slide-in-leave-to {
        opacity: 0;
        transform: translateY(10%);
    }
}
</style>
